import {Alert, Button, Card, Col, Container, Form, FormControl, FormGroup, FormText, Row} from "react-bootstrap";
import React, {createRef, useEffect, useState} from "react";
import useCallBackend from "../../hooks/use-call-backend";
import Error from "../../common/error";
import Loading from "../../common/loading";
import {ChangePassResponse} from "../../modal/change-pass-response";
import {OtpRequest} from "../../modal/otp-request";
import {ChangePassRequest} from "../../modal/change-pass-request";
import {Link, useLocation} from "react-router-dom";
import {Email} from "../../modal/email";
import "../../css/login.css"
// @ts-ignore
import lightstoneLogo from "../../assets/images/Lightstone-Logo.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import ContactInfo from "../../common/contact-info";

const ForgotPassword:React.FC<{isPassExpired: boolean}> = (props) => {
    const {isLoading:isOtpLoading, error:otpError, invokeBackend:sendOtp} = useCallBackend();
    const {isLoading, error, invokeBackend} = useCallBackend();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [otpSent, setOtpSent] = useState(false);
    const [passChanged, setPassChanged] = useState(false);
    const [email, setEmail] = useState("");
    const [emailReadonly, setEmailReadonly] = useState(false);
    const [pass, setPass] = useState("");
    const [confPass, setConfPass] = useState("");
    const [otp, setOtp] = useState("");
    const location = useLocation();
    const recaptchaRef = createRef<ReCAPTCHA>();
    const recapchaSiteKey = process.env.REACT_APP_RECAPCHA_SITEKEY === undefined ? "" : process.env.REACT_APP_RECAPCHA_SITEKEY;

    useEffect(() => {
        if(props.isPassExpired || location.state != null){
            const emailObj: Email = location.state as Email;
            if(emailObj != null){
                setEmail(emailObj.email);
                setEmailReadonly(true);
            }
        }
    }, [props.isPassExpired, location.state]);

    const handleOtpResponse = (otpResponse:ChangePassResponse) => {
        if(otpResponse.successful){
            setOtpSent(true);
        }else{
            setErrorMessage(otpResponse.message);
        }
    }

    const handleSendOneTimePin = () => {
        setErrorMessage(null); //reset
        if(email === ""){
            setErrorMessage("Email address is required.");
            return;
        }

        const otpRequest: OtpRequest = {email: email, isForForgetPassword: !props.isPassExpired};

        sendOtp({url: "/api/auth/sendOtp",
            dontAddAuth: true,
            method: "POST",
            body: JSON.stringify(otpRequest)},
            handleOtpResponse);
    }

    const handleChangePassResponse = (response:ChangePassResponse) => {
        if(response.successful){
            setPassChanged(true);
        }else{
            setErrorMessage(response.message);
        }
    }

    const handleFormSubmit = async (event:React.FormEvent) => {
        event.preventDefault();

        const token = await recaptchaRef.current?.executeAsync();

        if(token === undefined || token === null || token === ""){
            setErrorMessage("reCapcha failed!");
            return;
        }

        if(email === "" || pass === "" || confPass === "" || otp === "") {
            setErrorMessage("All fields are required!");
            return;
        }

        if(pass !== confPass){
            setErrorMessage("Password and Confirm Password does not match.");
            return;
        }

        const request: ChangePassRequest = {
            email: email,
            newPassword: pass,
            confirmPassword: confPass,
            oneTimePin: otp,
            isForForgotPassword: !props.isPassExpired,
            capcha: token
        }

        invokeBackend({url: "/api/auth/changePass",
            dontAddAuth: true,
            method: "POST",
            body: JSON.stringify(request)},
            handleChangePassResponse);


    }

    let displayError = null;

    if(otpError || error || errorMessage){
        displayError = (
            <Row>
                <Col>
                    {otpError && <Error message={otpError} />}
                    {error && <Error message={error} />}
                    {errorMessage && <Error message={errorMessage} />}
                </Col>
            </Row>
        );
    }

    const forgotForm = (<React.Fragment>
        {displayError}
        <Row>
            <Col>
                <Form onSubmit={handleFormSubmit}>
                    <FormGroup>
                        <FormControl type="email" placeholder="Email address" autoComplete="off" required value={email} readOnly={emailReadonly}
                                     onChange={(e) => {setEmail(e.target.value)}} />
                    </FormGroup>
                    <FormGroup className="d-flex align-items-center">
                        <Button variant="primary" className="mt-3" type="button" onClick={handleSendOneTimePin}>Send OTP</Button>
                        {otpSent && <div className="m-3">One time pin was sent.</div>}
                    </FormGroup>
                    <FormGroup className="mt-3">
                        <FormText>Password must be 8 to 16 characters long containing at least one number, uppercase, lowercase, and special character.</FormText>
                        <FormControl type="password" placeholder="New Password" autoComplete="off" required
                                     onChange={(e) => {setPass(e.target.value)}} />
                    </FormGroup>
                    <FormGroup className="mt-3">
                        <FormControl type="password" placeholder="Confirm Password" autoComplete="off" required
                                     onChange={(e) => {setConfPass(e.target.value)}}/>
                    </FormGroup>
                    <FormGroup className="mt-3">
                        <FormControl type="text" placeholder="One Time Pin" autoComplete="off" required value={otp}
                                     onChange={(e) => {setOtp(e.target.value)}} />
                    </FormGroup>
                    <FormGroup>
                        <Button variant="primary" className="mt-3" type="submit">Submit</Button>
                    </FormGroup>
                    <ReCAPTCHA sitekey={recapchaSiteKey} size="invisible" ref={recaptchaRef} />
                </Form>
            </Col>
        </Row>
    </React.Fragment>);

    const loadingContent = (
        <Row>
            <Col>
                <Loading overrideStyle="h2" />
            </Col>
        </Row>
    );

    const passwordSuccessfullyChanged = (<div>
        <Alert variant="success">Your password was successfully updated.</Alert>
        <Link to="/">Click here to go to login...</Link>
    </div>);

    return (<Container fluid className="login">
        <Row className="g-0 vh-100">
            <Col lg={6} className="d-flex justify-content-center align-items-center">
                <Row className="loginWidth">
                    <Col>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>Signio VAP Supplier Portal: {props.isPassExpired ? "Password has Expired" : "Forgot Password"}</Card.Header>
                                    <Card.Body>
                                        {(isLoading || isOtpLoading) && loadingContent}
                                        {passChanged && passwordSuccessfullyChanged}
                                        {!isLoading && !isOtpLoading && !passChanged && forgotForm}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <ContactInfo />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <img src={lightstoneLogo} alt="Lightstone Logo" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Container>);
}

export default ForgotPassword;